import {EquipmentCardEnums, EquipmentCardInterfaces, EquipmentEnums} from '@namespaces/equipment.namespace';
import {ApiModel} from './api-model';
import {Calibration} from './card/calibration';

/**
 * Карточка оборудования
 */
export class Card extends ApiModel<EquipmentCardInterfaces.Card.ItemView> {
    public id: number;
    public title: string;
    public status: string;
    public year: number;
    public serial: string;
    public calibration: Calibration;
    public isModerated: boolean;
    public photoUrl: string;

    /**
     * Списано?
     */
    public isDismissed: boolean;
    /**
     * Сообщение, если поверка нужна, но ее нет
     */
    public emptyCalibrationMessage: string;

    /**
     * @param _rawData - Данные от API в исходном виде
     */
    constructor(
        _rawData: EquipmentCardInterfaces.Card.ItemView
    ) {
        super(_rawData);
        this.setAttributes();
    }

    /**
     * Установить значения атрибутов из исходных данных
     */
    protected setAttributes() {
        const {calibration} = this.rawData;

        this.id = this.rawData.id;
        this.title = this.rawData.apparatus.title.trim();
        this.status = this.rawData.status_title;
        this.year = +this.rawData.year;
        this.serial = this.rawData.serial;
        this.calibration = calibration ? new Calibration(calibration, this.rawData.apparatus.verification_status) : null;
        this.isModerated = this.rawData.apparatus.is_moderated;
        this.photoUrl = this.rawData.apparatus.images.length ? this.rawData.apparatus.images[0].file_url : null;
        this.emptyCalibrationMessage = this.rawData.is_calibrated && !this.calibration ?
            `Отсутствует ${Calibration.getCalibrationLabel(this.rawData.apparatus.verification_status, 'поверка', 'калибровка')}` :
            null;
        this.isDismissed = this.rawData.status === EquipmentCardEnums.EquipmentStatus.dismiss;
    }
}
